export const PROVIDERS_REQUIRES_BANK = ['bradesco'];
export const PROVIDERS_REQUIRES_CANVASSER = ['bradesco', 'odontoprev'];
